<template>
  <FITFormCard>
    <div slot="header">
      <b-row>
        <b-col cols=8>
          <p class="h4">{{ $t('adm.agent.header') }}</p>
        </b-col>
        <b-col cols="4" class="text-right">
          <b-button variant="primary" size="md" @click="createNewAgent">{{ $t('adm.agent.create') }}</b-button>
        </b-col>
      </b-row>
    </div>
    <div slot="formBody">
      <b-alert variant="success" dismissible :show="shouldShowSuccessMessage">
        <span class="h5"><i class="fa fa-check-circle mr-2"></i>{{ $t('adm.agent.success') }}</span>
      </b-alert>
      <FITSearchableTable :filters="filters" :actions="actions" :columns="columns" searchAction="getAgentList" vuexModule="Adm" type="agent" @onRowSelected="onRowSelected"></FITSearchableTable>
    </div>
  </FITFormCard>
</template>
<script type="text/javascript">
import {
  FITPagination,
  FITFormCard,
  FITSelect,
  FITButton,
  FITTextInput,
  FITDatePicker,
  FITSearchableTable
} from '@/components';

import Vue from 'vue';
import { mapGetters } from 'vuex';

export default {
  name: 'AgentList',
  components: {
    FITPagination,
    FITFormCard,
    FITSelect,
    FITButton,
    FITTextInput,
    FITDatePicker,
    FITSearchableTable
  },
  data() {
    return {
      //FITSeachableTable

      filters: [{
        label: this.$t('adm.agent.position'),
        key: 'position',
        type: 'select',
        default: null, // Default All
      }],
      columns: [
        { key: 'agentCode', label: this.$t('adm.agent.agentCode'), sortable: true },
        {
          key: 'agentName',
          label: this.$t('adm.agent.name'),
          formatter: (row, key, item) => {
            return item.englishLastname.toUpperCase() + ' ' + item.englishFirstname + "</br>" + item.chineseLastname +item.chineseFirstname;
          }
        },
        {
          key: 'gender',
          label: this.$t('general.gender'),
          sortable: true,
          formatter: (row, key, item) => {
            // console.log(row);
            // if(row=="M"){ return "Male";}else if (row == "F"){ return "Female";}

            if (!row) { return "N/A"; }
            return this.$t('general.' + row);
          }
        },
        {
          key: 'position',
          label: this.$t('adm.agent.position'),
          sortable: true,
          formatter: (row, key, item) => {
            return this.getTranslated(key, row);
          }
        },
        // { key: 'userEmail', label: this.$t('adm.agent.userEmail'),sortable: true },
        {
          key: 'contactType',
          label: this.$t('adm.agent.contactType'),
          sortable: true,
          formatter: (row, key, item) => {
            return this.getTranslated(key, row);
          }
        },
        // {
        //   key: 'idType',
        //   label: this.$t('adm.agent.idType'),
        //   sortable: true,
        //   formatter: (row, key, item) => {
        //     return this.getTranslated(key, row);
        //   }
        // },
        // {
        //   key: 'maritalStatus',
        //   label: this.$t('adm.agent.maritalStatus'),
        //   sortable: true,
        //   formatter: (row, key, item) => {
        //     return this.getTranslated(key, row);
        //   }
        // },

      ],
      actions: [],

      search: {
        position: null,
        search: null
      },

      gender: {
        'M': 'Male',
        'F': 'Female'
      },

      data: {
        total: 0,
        list: []
      },

      pagination: {
        currentPage: 1,
        perPage: 20
      },

      fields: [
        { key: 'agentCode', label: this.$t('adm.agent.agentCode'), class: "align-middle" },
        { key: 'agentName', label: this.$t('adm.agent.name'), class: "align-middle" },
        { key: 'gender', label: this.$t('general.gender'), class: "align-middle" },
        { key: 'position', label: this.$t('adm.agent.position'), class: "align-middle" },
        { key: 'userEmail', label: this.$t('adm.agent.userEmail'), class: 'text-center align-left' }
      ],

      busy: false,
      timeout: null,

      shouldShowSuccessMessage: false
    }
  },

  props: {
    createSuccess: {
      type: Boolean,
      required: false
    }
  },

  computed: {
    ...mapGetters(['getTranslatedArray']),

    // ...mapGetters('Adm', ['getTranslated']),
    // total() {
    //   return `${this.$t('crm.lead.page')} ${this.pagination.currentPage} / ${this.$t('crm.lead.total')} ${this.data.total} ${this.$t('crm.lead.items')}`;
    // },
    // positions() {
    //   let result = this.getTranslated(this.$i18n.locale, 'position');
    //   result.unshift({ text: 'All', value: null });
    //   return result;
    // }
  },

  watch: {
    // pagination: {
    //   deep: true,
    //   handler(val) {
    //     this.refreshPage();
    //   }
    // },

    // search: {
    //   handler(val) {
    //     if (this.busy) {
    //       return;
    //     }

    //     Vue.set(this, 'busy', true);
    //     if (timeout) {
    //       clearTimeout(this.timeout);
    //     }

    //     let timeout = setTimeout(() => {
    //       Vue.set(this, 'busy', false);
    //       Vue.set(this, 'timeout', null);
    //     }, 1500);

    //     this.refreshPage();
    //   },
    //   deep: true // watch nested
    // }
  },

  methods: {
    // getConvertedPosition(key) {
    //   let result = this.positions.filter((item) => item.value === key);
    //   if (result.length > 0) {
    //     return result[0].text;
    //   }

    //   return 'N/A';
    // },

    // clearFilter() {
    //   Vue.set(this, 'search', {
    //     position: null,
    //     keywords: null
    //   });
    // },

    createNewAgent() {
      this.$router.push('/adm/agent/create');
    },

    onRowSelected(item) {
      this.$router.push({
        name: 'Create Agent',
        params: { ID: parseInt(item.ID) }
      });
    },
    getTranslated(type, key) {
      if (!key) {
        return 'N/A';
      }
      let result = this.getTranslatedArray(this.$i18n.locale, 'Adm', type)
        .filter((item) => {
          return item.value === key
        });
      if (result.length > 0) {
        return result[0].text;
      }
      return 'N/A';
    }

    //   onPageChanged(newPage) {
    //     // Vue.set(this.pagination, 'currentPage', newPage);
    //   },

    //   refreshPage() {
    //     let param = {};
    //     Object.keys(this.search).forEach((item) => {
    //       if (this.search[item] != null) {
    //         param = {
    //           ...param,
    //           [item]: this.search[item]
    //         }
    //       }
    //     });

    //     this.$store.dispatch('Adm/getAgentList', {
    //       page: this.pagination.currentPage,
    //       count: this.pagination.perPage,
    //       ...param
    //     }).then((json) => {
    //       Vue.set(this, 'data', json.data);
    //     }).catch((err) => {
    //       console.error(err);
    //     });
    //   }
  },

  created() {
    // this.$store.dispatch('getAllSelections', 'agent')
    //   .then((json) => {
    //     this.$store.commit({ type: 'Adm/setSelections', selection: json.data });
    //   })
    //   .catch((err) => {
    //     console.error(err);
    //   });
    // this.refreshPage();
  },

  mounted() {

    if (this.createSuccess) {
      Vue.set(this, 'shouldShowSuccessMessage', true);
      setTimeout(() => {
        Vue.set(this, 'shouldShowSuccessMessage', false);
      }, 3000);
    }
  }
}

</script>
<style>
.pointer-cursor .table tbody tr,
.pointer-cursor .table tbody td {
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/Adm/Agent/AgentList.vue